import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { appendTeamMemberLawyerId } from "../../../../styles/styles";

export const getAllStatement = createAsyncThunk(
  "accounts/getAllStatement",
  async ({ url, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const getBankDetail = createAsyncThunk(
  "accounts/getBankDetail",
  async ({ url, token }) => {
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const getAllAccounts = createAsyncThunk(
  "accounts/getAllAccounts",
  async ({ url, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const UpdateAccounts = createAsyncThunk(
  "accounts/UpdateAccounts",
  async ({ url, body, token }) => {
    try {
      const response = await axios.put(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const UpdateTransaction = createAsyncThunk(
  "accounts/UpdateTransaction",
  async ({ url, body, token }) => {
    try {
      const response = await axios.put(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

const AccountSlice = createSlice({
  name: "account",
  initialState: {
    AllAccounts: null, // All accounts data
    accountsPagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    bankDetail: null,
    allStatement: null,
    statementPagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.AllAccounts = action?.payload?.results || action?.payload;
        state.accountsPagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getAllAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action?.error?.message || "Account is not there Create one ";
      })
      .addCase(getBankDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBankDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.bankDetail = action?.payload || action?.payload?.results;
      })
      .addCase(getBankDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.error?.message || "Failed to get account";
      })
      .addCase(UpdateAccounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.AllAccounts = action?.payload;
      })
      .addCase(UpdateAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.error?.message || "Failed to update account ";
      })
      .addCase(getAllStatement.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllStatement.fulfilled, (state, action) => {
        state.loading = false;
        state.allStatement = action?.payload?.results || action?.payload;
        state.statementPagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getAllStatement.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.error?.message || "Failed to get statement";
      });
  },
});

export const AccountReducer = AccountSlice.reducer;
